import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "\n      pt-2\n      bg-white\n      flex flex-col\n      text-12px\n      xxl:text-14px\n      overflow-hidden\n      h-screen\n      relative\n      w-full\n    " }
const _hoisted_2 = { class: "space-y-6 ml-4 overflow-y-auto" }
const _hoisted_3 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_4 = { class: "pr-6" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_PrintManifest = _resolveComponent("PrintManifest")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.getTitle,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getDetail
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Title, {
            label: _ctx.$t('Detail Custom Process')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: "ID",
              class: "w-6/12",
              value: _ctx.id
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.isInternalOrCs ? _ctx.$t('Nama User') : _ctx.$t('Nama Partner'),
              class: "w-6/12 capitalize",
              value: _ctx.partnerName
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.isInternalOrCs ? _ctx.$t('Tipe User') : _ctx.$t('Tipe Partner'),
              value: _ctx.typeUser,
              class: "w-6/12 capitalize"
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Custom Status'),
              value: _ctx.detailData.customProcessLatestStatus,
              class: "w-6/12"
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total STT'),
              value: _ctx.formattedTotalStt,
              class: "w-6/12"
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total Koli'),
              value: _ctx.formattedTotalPiece,
              class: "w-6/12"
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total Berat Kotor'),
              value: _ctx.formattedTotalGrossWeight,
              class: "w-6/12"
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('Total Berat Dikenakan Biaya'),
              value: _ctx.formattedTotalChargeableWeight,
              class: "w-6/12"
            }, null, 8, ["label", "value"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_TableV2, {
              data: _ctx.detailData.stt,
              columns: _ctx.columns,
              borderTop: false,
              hidePagination: true,
              isRightFreeze: true,
              isPinnedScrollBottom: false,
              totalColumnFreeze: 0
            }, null, 8, ["data", "columns"])
          ])
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('Tanggal Dibuat'),
          value: _ctx.convertCreatedAt,
          caption: _ctx.detailData.customProcessCreatedBy
        }, null, 8, ["label", "value", "caption"]),
        _hoisted_5,
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('Print Resi Custom Process')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpButton, {
              onClick: _ctx.printManifest,
              class: "mt-3 w-48",
              flat: "",
              dense: "",
              iconLeft: "printer",
              title: _ctx.$t('Print PDF')
            }, null, 8, ["onClick", "title"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]),
    _createVNode(_component_PrintManifest, { ref: "printManifest" }, null, 512)
  ]))
}